import PropTypes from "prop-types";

import { Button, Tooltip } from "@mui/material";

// Tooltip only shows up if the title is not empty.
// Loading also only shows up when the loading prop is not empty.
// No need to render these two conditionally.
function HubDialogActionButton(props) {
  return (
    <Tooltip title={props.tooltip} placement={props.tooltipPlacement || "top"}>
      <span>
        <Button
          variant={props.variant || "contained"}
          size={props.size || "small"}
          onClick={props.onClick}
          loading={props.loading}
          disabled={props.disabled}
          color={props.color}
          sx={props.sx}
        >
          {props.title}
        </Button>
      </span>
    </Tooltip>
  );
}

HubDialogActionButton.propTypes = {
  loading: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  color: PropTypes.string,
  sx: PropTypes.object,
  title: PropTypes.string,
  tooltip: PropTypes.node,
  tooltipPlacement: PropTypes.string,
};

export default HubDialogActionButton;
